/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Webplatform-ts V2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetV2Organizations200Item,
  GetV2OrganizationsAgreementsMint200,
  GetV2OrganizationsAgreementsRedeem200,
  GetV2OrganizationsParams,
  PutV2Organizations200Item,
  PutV2OrganizationsAgreementsMint200,
  PutV2OrganizationsAgreementsMintBody,
  PutV2OrganizationsAgreementsRedeem200,
  PutV2OrganizationsAgreementsRedeemBody,
  PutV2OrganizationsBodyItem
} from '../../model';

import { webplatformProxyInstance } from '../../../../../lib/integrations/axios.ts';
import type { ErrorType } from '../../../../../lib/integrations/axios.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * This endpoint returns the status of the minting agreement based on the Organization ID in the auth token
 * @summary Retrieve minting agreement status for an organization
 */
export const getV2OrganizationsAgreementsMint = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV2OrganizationsAgreementsMint200>(
      {url: `/v2/organizations/agreements/mint`, method: 'GET', signal
    },
      options);
    }




export const getGetV2OrganizationsAgreementsMintQueryKey = () => {
    return [
    `/v2/organizations/agreements/mint`
    ] as const;
    }


export const getGetV2OrganizationsAgreementsMintQueryOptions = <TData = Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV2OrganizationsAgreementsMintQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>> = ({ signal }) => getV2OrganizationsAgreementsMint(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV2OrganizationsAgreementsMintQueryResult = NonNullable<Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>>
export type GetV2OrganizationsAgreementsMintQueryError = ErrorType<unknown>


export function useGetV2OrganizationsAgreementsMint<TData = Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>,
          TError,
          Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2OrganizationsAgreementsMint<TData = Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>,
          TError,
          Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2OrganizationsAgreementsMint<TData = Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve minting agreement status for an organization
 */

export function useGetV2OrganizationsAgreementsMint<TData = Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationsAgreementsMint>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV2OrganizationsAgreementsMintQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Insert or update minting agreements. Note: You cannot set it to false through this API if it already passed.
 * @summary Update minting agreements for an organization
 */
export const putV2OrganizationsAgreementsMint = (
    putV2OrganizationsAgreementsMintBody: PutV2OrganizationsAgreementsMintBody,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<PutV2OrganizationsAgreementsMint200>(
      {url: `/v2/organizations/agreements/mint`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putV2OrganizationsAgreementsMintBody, signal
    },
      options);
    }




export const getPutV2OrganizationsAgreementsMintMutationKey = () => ['putV2OrganizationsAgreementsMint'] as const;

export const getPutV2OrganizationsAgreementsMintMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2OrganizationsAgreementsMint>>, TError,PutV2OrganizationsAgreementsMintMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putV2OrganizationsAgreementsMint>>, TError,PutV2OrganizationsAgreementsMintMutationVariables, TContext> => {

const mutationKey = getPutV2OrganizationsAgreementsMintMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putV2OrganizationsAgreementsMint>>, PutV2OrganizationsAgreementsMintMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putV2OrganizationsAgreementsMint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutV2OrganizationsAgreementsMintMutationResult = NonNullable<Awaited<ReturnType<typeof putV2OrganizationsAgreementsMint>>>
    export type PutV2OrganizationsAgreementsMintMutationBody = PutV2OrganizationsAgreementsMintBody
    export type PutV2OrganizationsAgreementsMintMutationError = ErrorType<unknown>
    export type PutV2OrganizationsAgreementsMintMutationVariables = {data: PutV2OrganizationsAgreementsMintBody}

    /**
 * @summary Update minting agreements for an organization
 */
export const usePutV2OrganizationsAgreementsMint = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2OrganizationsAgreementsMint>>, TError,PutV2OrganizationsAgreementsMintMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putV2OrganizationsAgreementsMint>>,
        TError,
        PutV2OrganizationsAgreementsMintMutationVariables,
        TContext
      > => {
      return useMutation(getPutV2OrganizationsAgreementsMintMutationOptions(options), queryClient);
    }
    /**
 * This endpoint returns the status of the redeeming agreement based on the Organization ID in the auth token
 * @summary Retrieve redeeming agreement status for an organization
 */
export const getV2OrganizationsAgreementsRedeem = (

 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV2OrganizationsAgreementsRedeem200>(
      {url: `/v2/organizations/agreements/redeem`, method: 'GET', signal
    },
      options);
    }




export const getGetV2OrganizationsAgreementsRedeemQueryKey = () => {
    return [
    `/v2/organizations/agreements/redeem`
    ] as const;
    }


export const getGetV2OrganizationsAgreementsRedeemQueryOptions = <TData = Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV2OrganizationsAgreementsRedeemQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>> = ({ signal }) => getV2OrganizationsAgreementsRedeem(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV2OrganizationsAgreementsRedeemQueryResult = NonNullable<Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>>
export type GetV2OrganizationsAgreementsRedeemQueryError = ErrorType<unknown>


export function useGetV2OrganizationsAgreementsRedeem<TData = Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>,
          TError,
          Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2OrganizationsAgreementsRedeem<TData = Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>,
          TError,
          Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2OrganizationsAgreementsRedeem<TData = Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve redeeming agreement status for an organization
 */

export function useGetV2OrganizationsAgreementsRedeem<TData = Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2OrganizationsAgreementsRedeem>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV2OrganizationsAgreementsRedeemQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Insert or update redeeming agreements. Note: You cannot set it to false through this API if it already passed.
 * @summary Update redeeming agreements for an organization
 */
export const putV2OrganizationsAgreementsRedeem = (
    putV2OrganizationsAgreementsRedeemBody: PutV2OrganizationsAgreementsRedeemBody,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<PutV2OrganizationsAgreementsRedeem200>(
      {url: `/v2/organizations/agreements/redeem`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putV2OrganizationsAgreementsRedeemBody, signal
    },
      options);
    }




export const getPutV2OrganizationsAgreementsRedeemMutationKey = () => ['putV2OrganizationsAgreementsRedeem'] as const;

export const getPutV2OrganizationsAgreementsRedeemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2OrganizationsAgreementsRedeem>>, TError,PutV2OrganizationsAgreementsRedeemMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putV2OrganizationsAgreementsRedeem>>, TError,PutV2OrganizationsAgreementsRedeemMutationVariables, TContext> => {

const mutationKey = getPutV2OrganizationsAgreementsRedeemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putV2OrganizationsAgreementsRedeem>>, PutV2OrganizationsAgreementsRedeemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putV2OrganizationsAgreementsRedeem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutV2OrganizationsAgreementsRedeemMutationResult = NonNullable<Awaited<ReturnType<typeof putV2OrganizationsAgreementsRedeem>>>
    export type PutV2OrganizationsAgreementsRedeemMutationBody = PutV2OrganizationsAgreementsRedeemBody
    export type PutV2OrganizationsAgreementsRedeemMutationError = ErrorType<unknown>
    export type PutV2OrganizationsAgreementsRedeemMutationVariables = {data: PutV2OrganizationsAgreementsRedeemBody}

    /**
 * @summary Update redeeming agreements for an organization
 */
export const usePutV2OrganizationsAgreementsRedeem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2OrganizationsAgreementsRedeem>>, TError,PutV2OrganizationsAgreementsRedeemMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putV2OrganizationsAgreementsRedeem>>,
        TError,
        PutV2OrganizationsAgreementsRedeemMutationVariables,
        TContext
      > => {
      return useMutation(getPutV2OrganizationsAgreementsRedeemMutationOptions(options), queryClient);
    }
    /**
 * Get Organizations with filters
 * @summary Get Organizations with filters
 */
export const getV2Organizations = (
    params?: GetV2OrganizationsParams,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<GetV2Organizations200Item[]>(
      {url: `/v2/organizations`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetV2OrganizationsQueryKey = (params?: GetV2OrganizationsParams,) => {
    return [
    `/v2/organizations`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetV2OrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getV2Organizations>>, TError = ErrorType<unknown>>(params?: GetV2OrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Organizations>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV2OrganizationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2Organizations>>> = ({ signal }) => getV2Organizations(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV2Organizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV2OrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getV2Organizations>>>
export type GetV2OrganizationsQueryError = ErrorType<unknown>


export function useGetV2Organizations<TData = Awaited<ReturnType<typeof getV2Organizations>>, TError = ErrorType<unknown>>(
 params: undefined |  GetV2OrganizationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Organizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2Organizations>>,
          TError,
          Awaited<ReturnType<typeof getV2Organizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2Organizations<TData = Awaited<ReturnType<typeof getV2Organizations>>, TError = ErrorType<unknown>>(
 params?: GetV2OrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Organizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2Organizations>>,
          TError,
          Awaited<ReturnType<typeof getV2Organizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2Organizations<TData = Awaited<ReturnType<typeof getV2Organizations>>, TError = ErrorType<unknown>>(
 params?: GetV2OrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Organizations>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organizations with filters
 */

export function useGetV2Organizations<TData = Awaited<ReturnType<typeof getV2Organizations>>, TError = ErrorType<unknown>>(
 params?: GetV2OrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Organizations>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV2OrganizationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Update Organizations in batch
 * @summary Update Organizations in batch
 */
export const putV2Organizations = (
    putV2OrganizationsBodyItem: PutV2OrganizationsBodyItem[],
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<PutV2Organizations200Item[]>(
      {url: `/v2/organizations`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putV2OrganizationsBodyItem, signal
    },
      options);
    }




export const getPutV2OrganizationsMutationKey = () => ['putV2Organizations'] as const;

export const getPutV2OrganizationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2Organizations>>, TError,PutV2OrganizationsMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putV2Organizations>>, TError,PutV2OrganizationsMutationVariables, TContext> => {

const mutationKey = getPutV2OrganizationsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putV2Organizations>>, PutV2OrganizationsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putV2Organizations(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutV2OrganizationsMutationResult = NonNullable<Awaited<ReturnType<typeof putV2Organizations>>>
    export type PutV2OrganizationsMutationBody = PutV2OrganizationsBodyItem[]
    export type PutV2OrganizationsMutationError = ErrorType<unknown>
    export type PutV2OrganizationsMutationVariables = {data: PutV2OrganizationsBodyItem[]}

    /**
 * @summary Update Organizations in batch
 */
export const usePutV2Organizations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putV2Organizations>>, TError,PutV2OrganizationsMutationVariables, TContext>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putV2Organizations>>,
        TError,
        PutV2OrganizationsMutationVariables,
        TContext
      > => {
      return useMutation(getPutV2OrganizationsMutationOptions(options), queryClient);
    }
